/*
 * TUMLE: previous/next buttons over the main product image.
 * They step through the gallery's own thumbnails and click the next visible
 * one, so media-gallery.js does the switching: desktop active image, mobile
 * scroll position, active thumbnail. Thumbnails hidden for other variants are
 * skipped. Wraps around at both ends.
 */
if (!customElements.get('tumle_gallery-arrows')) {
  customElements.define(
    'tumle_gallery-arrows',
    class TumleGalleryArrows extends HTMLElement {
      connectedCallback() {
        this.gallery = this.closest('media-gallery');
        if (!this.gallery || !this.thumbnails().length) {
          this.hidden = true;
          return;
        }
        this.querySelectorAll('[data-step]').forEach((button) =>
          button.addEventListener('click', () => this.step(Number(button.dataset.step)))
        );
      }

      thumbnails() {
        const list = this.gallery?.querySelector('[id^="GalleryThumbnails"]');
        if (!list) return [];
        // Visible ones only: variant images can be hidden per selected variant
        return [...list.querySelectorAll('[data-target]')].filter((item) => item.offsetParent !== null || item.getClientRects().length);
      }

      step(direction) {
        const items = this.thumbnails();
        if (items.length < 2) return;
        const current = items.findIndex((item) => item.querySelector('button[aria-current="true"]'));
        const next = items[(Math.max(current, 0) + direction + items.length) % items.length];
        next.querySelector('button')?.click();
      }
    }
  );
}
